import { createApp } from 'vue';
import App from './App.vue';
import { router } from './router';
import { store } from './store';
import ElementPlus from 'element-plus';
import locale from 'element-plus/lib/locale/lang/zh-cn';
import SanpackPlugin from 'codesandbox-sandpack-vue3';
import './common/element-variables.scss';
import './common/reset.scss';

const app = createApp(App);
app.use(router);
app.use(store);
app.use(SanpackPlugin());
app.use(ElementPlus,  { locale });
app.mount('#app');
